"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var component_1 = require("./component");
var consumer_1 = require("./consumer");
var logger_1 = require("./logger");
var utils_1 = require("./utils");
var bernie_logger_1 = require("bernie-logger");
var _1 = require(".");
var RedirectBannerComponents = (function (_super) {
    __extends(RedirectBannerComponents, _super);
    function RedirectBannerComponents(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { bannerModel: undefined, bannerModelV1: undefined };
        _this.loggerUtility = new logger_1.LoggerUtility();
        return _this;
    }
    RedirectBannerComponents.prototype.componentDidMount = function () {
        if (!this.props.siteid) {
            this.loggerUtility.logMessage(bernie_logger_1.SystemEventLevel.ERROR, utils_1.ErrorMessages.MISSING_SITEID_ERROR_MSG);
            return;
        }
        var redirectBannerConsumer = new consumer_1.RedirectBannerAPIConsumer(this.props);
        if (this.props.expVariant == utils_1.ExpVariant.VARIANT_1) {
            this.setResponseFromPromiseForV1(redirectBannerConsumer);
        }
        else {
            this.setResponseFromPromise(redirectBannerConsumer);
        }
    };
    RedirectBannerComponents.prototype.render = function () {
        var _a = this.state, bannerModel = _a.bannerModel, bannerModelV1 = _a.bannerModelV1;
        if (bannerModel && Object.keys(bannerModel).length > 0) {
            return (React.createElement("div", { className: "redirect-banner-designV1 uitk-flex" },
                React.createElement("div", { className: "redirect-banner-content uitk-flex-grow-1 uitk-flex uitk-flex-align-items-center" },
                    React.createElement("div", { className: "uitk-flex-grow-1" },
                        React.createElement("p", { tabIndex: 0, className: "redirect-banner-body" },
                            React.createElement(component_1.WelcomeText, { textValue: bannerModel.welcomeText }),
                            React.createElement(component_1.CallToAction, { textValue: bannerModel.callToActionText, posaLink: bannerModel.POSaLink, analytics: bannerModel.analytics }))))));
        }
        else if (bannerModelV1 && Object.keys(bannerModelV1).length > 0) {
            return React.createElement(_1.RedirectBannerV1, { bannerModelV1: bannerModelV1 });
        }
        return React.createElement(React.Fragment, null);
    };
    RedirectBannerComponents.prototype.setResponseFromPromiseForV1 = function (redirectBannerConsumer) {
        var _this = this;
        var redirectBannerDataPromise = redirectBannerConsumer.fetchRedirectBannerDataV1();
        if (redirectBannerDataPromise) {
            redirectBannerDataPromise
                .then(function (response) {
                if (response.parsedBody) {
                    _this.setState({ bannerModelV1: response.parsedBody });
                }
            })
                .catch(function (err) {
                _this.loggerUtility.logMessage(bernie_logger_1.SystemEventLevel.ERROR, utils_1.ErrorMessages.BANNER_API_ERROR_MSG);
            });
        }
    };
    RedirectBannerComponents.prototype.setResponseFromPromise = function (redirectBannerConsumer) {
        var _this = this;
        var redirectBannerDataPromise = redirectBannerConsumer.fetchRedirectBannerData();
        if (redirectBannerDataPromise) {
            redirectBannerDataPromise
                .then(function (response) {
                if (response.parsedBody) {
                    _this.setState({ bannerModel: response.parsedBody });
                }
            })
                .catch(function (err) {
                _this.loggerUtility.logMessage(bernie_logger_1.SystemEventLevel.ERROR, utils_1.ErrorMessages.BANNER_API_ERROR_MSG);
            });
        }
    };
    return RedirectBannerComponents;
}(React.Component));
exports.RedirectBannerComponents = RedirectBannerComponents;
//# sourceMappingURL=redirect-banner-components.js.map